/**
 * @module
 * @ignore
 */

/**
 * Joins the passed arguments into a string delimited by a space,
 * trimming out empty values.
 *
 * @param   {...string} names
 *
 * @returns {string}
 * @private
 */
export default function joinName(...names) {
  return names.map(s => s && String(s).trim()).filter(Boolean).join(' ');
}